(function () {
  'use strict';

  var config = window.HENGE_CLEAR_ANALYTICS_CONFIG || {};
  var environment = String(config.environment || '');
  if (environment !== 'production' && environment !== 'test') return;
  var endpoint = String(config.endpoint || '');
  var experimentId = String(config.experimentId || '');
  var prefix = environment === 'test' ? 'henge_test_' : '';
  var keys = {
    visitor: prefix + 'henge_clear_202609_visitor',
    session: prefix + 'henge_clear_202609_session',
    assignment: prefix + 'henge_clear_ab_' + experimentId,
    journey: prefix + 'henge_clear_header_journey',
    queue: prefix + 'henge_clear_header_journey_pending',
    applicationPending: prefix + 'henge_clear_202609_application_pending',
    applicationDone: prefix + 'henge_clear_202609_application_done',
    application: prefix + 'henge_clear_202609_application',
    applicationTab: prefix + 'henge_clear_202609_application_tab'
  };
  var path = normalizePath(window.location.pathname);
  var isLpA = path === '/pages/clearlp';
  var isClearTrackerPage = ['/pages/clearlp', '/pages/henge-clear', '/pages/thanks'].indexOf(path) >= 0;
  var pendingTtl = 24 * 60 * 60 * 1000;
  var journeyTtl = 24 * 60 * 60 * 1000;
  var maxAttempts = 9;
  var pendingInteraction = null;

  function normalizePath(value) { var p = String(value || '/').replace(/\/+$/, ''); return p || '/'; }
  function get(storage, key) { try { return storage.getItem(key); } catch (e) { return null; } }
  function set(storage, key, value) { try { storage.setItem(key, value); return true; } catch (e) { return false; } }
  function remove(storage, key) { try { storage.removeItem(key); } catch (e) {} }
  function json(value, fallback) { try { return value ? JSON.parse(value) : fallback; } catch (e) { return fallback; } }
  function cookie(name) {
    try { var parts = document.cookie ? document.cookie.split('; ') : []; for (var i = 0; i < parts.length; i++) { var pair = parts[i].split('='); if (decodeURIComponent(pair.shift() || '') === name) return decodeURIComponent(pair.join('=')); } } catch (e) {}
    return '';
  }
  function uuid(prefixValue) {
    if (window.crypto && window.crypto.randomUUID) return prefixValue + window.crypto.randomUUID();
    return prefixValue + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
  }
  function valid(value, prefixValue) { return typeof value === 'string' && value.indexOf(prefixValue) === 0 && value.length <= 84; }
  function clean(value, max) { return String(value || '').replace(/[<>\u0000-\u001f\u007f]/g, '').trim().slice(0, max || 180); }
  function internalUrl(value) { try { var url = new URL(value, window.location.href); return url.origin === window.location.origin ? url : null; } catch (e) { return null; } }
  function sanitizedUrl(value) { var url = internalUrl(value); return url ? url.origin + normalizePath(url.pathname) : ''; }
  function pageCategory(value) {
    var p = normalizePath(value);
    if (p === '/') return 'home';
    if (p === '/search') return 'search';
    if (p === '/cart') return 'cart';
    if (p.indexOf('/account') === 0) return 'account';
    if (p === '/pages/clearlp' || p === '/pages/henge-clear') return 'lp';
    if (p === '/pages/about' || p === '/pages/company') return 'about';
    if (p === '/pages/restaurant') return 'restaurant';
    if (p.indexOf('/products/') === 0 || p.indexOf('/collections/') === 0 || p === '/pages/clear-hiire' || p === '/pages/clear-nama-hiire') return 'product';
    if (p.indexOf('/blogs/') === 0 || p === '/pages/holiday_page') return 'news';
    if (/award|awards/.test(p)) return 'award';
    if (/voice|review/.test(p)) return 'voice';
    if (/brewing|brewery|craft|kura/.test(p)) return 'brewing';
    return 'other';
  }
  function visitorId() { return get(window.localStorage, keys.visitor) || get(window.sessionStorage, keys.visitor) || cookie(keys.visitor); }
  function sessionId() {
    var item = json(get(window.sessionStorage, keys.session), null);
    if (item && valid(item.id, 'cs_')) return item.id;
    var visitor = visitorId();
    if (!valid(visitor, 'cv_')) return '';
    item = { id: uuid('cs_'), visitor_id: visitor, landing_at: new Date().toISOString(), touched_at: Date.now() };
    set(window.sessionStorage, keys.session, JSON.stringify(item));
    return item.id;
  }
  function assignment() {
    var item = json(get(window.localStorage, keys.assignment) || cookie(keys.assignment), null);
    return item && item.variant === 'a' ? item : null;
  }
  function readJourney() {
    var value = json(get(window.localStorage, keys.journey), null);
    if (!value || !valid(value.header_journey_id, 'chj_') || Date.now() - Number(value.header_exit_ms || 0) > journeyTtl) { remove(window.localStorage, keys.journey); return null; }
    return value;
  }
  function saveJourney(value) { set(window.localStorage, keys.journey, JSON.stringify(value)); }
  function queue() { var value = json(get(window.localStorage, keys.queue), []); return Array.isArray(value) ? value : []; }
  function saveQueue(value) { if (value.length) set(window.localStorage, keys.queue, JSON.stringify(value.slice(-50))); else remove(window.localStorage, keys.queue); }
  function resendApplicationPending() {
    if (isClearTrackerPage || !endpoint) return;
    var pending = json(get(window.localStorage, keys.applicationPending), null);
    var payload = pending && pending.payload, created = Date.parse(pending && pending.created_at || '');
    if (!pending) return;
    if (!payload || pending.environment !== environment || pending.application_id !== payload.application_id ||
        payload.kind !== 'application' || !valid(payload.application_id, 'ca_') || !isFinite(created) ||
        Date.now() - created > pendingTtl || Number(pending.retry_count || 0) >= maxAttempts) {
      remove(window.localStorage, keys.applicationPending);
      return;
    }
    function attempt(number) {
      if (Number(pending.retry_count || 0) >= maxAttempts) return;
      pending.retry_count = Number(pending.retry_count || 0) + 1;
      set(window.localStorage, keys.applicationPending, JSON.stringify(pending));
      window.fetch(endpoint, { method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(payload) })
        .then(function (response) { if (!response.ok) throw new Error('APPLICATION_HTTP_ERROR'); return response.json(); })
        .then(function (result) {
          if (result && result.ok === true && result.kind === 'application' && result.id === payload.application_id) {
            remove(window.localStorage, keys.applicationPending);
            set(window.localStorage, keys.applicationDone, payload.application_id);
            remove(window.localStorage, keys.application);
            remove(window.sessionStorage, keys.applicationTab);
            remove(window.localStorage, keys.journey);
            return;
          }
          if (number < 3 && result && result.retryable === true) window.setTimeout(function () { attempt(number + 1); }, 300 * Math.pow(2, number - 1));
          else if (result && result.retryable !== true) remove(window.localStorage, keys.applicationPending);
        }).catch(function () { if (number < 3) window.setTimeout(function () { attempt(number + 1); }, 300 * Math.pow(2, number - 1)); });
    }
    attempt(1);
  }
  function enqueue(payload) {
    var items = queue();
    items.push({ event_id: payload.event_id, created_at: new Date().toISOString(), retry_count: 0, environment: environment, payload: payload });
    saveQueue(items);
    flushQueue();
  }
  function sendQueued(item, immediateAttempt) {
    var created = Date.parse(item.created_at || '');
    if (!endpoint || !isFinite(created) || Date.now() - created > pendingTtl || Number(item.retry_count || 0) >= maxAttempts) return;
    item.retry_count = Number(item.retry_count || 0) + 1;
    var items = queue();
    items.forEach(function (queued) { if (queued.event_id === item.event_id) queued.retry_count = item.retry_count; });
    saveQueue(items);
    window.fetch(endpoint, { method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true,
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(item.payload) })
      .then(function (response) { if (!response.ok) throw new Error('HEADER_JOURNEY_HTTP'); return response.json(); })
      .then(function (result) {
        if (result && result.ok === true && result.kind === 'header_journey' && result.id === item.event_id) {
          saveQueue(queue().filter(function (queued) { return queued.event_id !== item.event_id; }));
          return;
        }
        if (immediateAttempt < 3 && Number(item.retry_count || 0) < maxAttempts && result && result.retryable === true) {
          window.setTimeout(function () { sendQueued(item, immediateAttempt + 1); }, 300 * Math.pow(2, immediateAttempt - 1));
        }
      }).catch(function () {
        if (immediateAttempt < 3 && Number(item.retry_count || 0) < maxAttempts) {
          window.setTimeout(function () { sendQueued(item, immediateAttempt + 1); }, 300 * Math.pow(2, immediateAttempt - 1));
        }
      });
  }
  function flushQueue() {
    if (!endpoint) return;
    var items = queue(), now = Date.now(), active = items.filter(function (item) {
      var created = Date.parse(item.created_at || '');
      return item && item.environment === environment && item.payload && item.event_id === item.payload.event_id && isFinite(created) && now - created <= pendingTtl && Number(item.retry_count || 0) < maxAttempts;
    });
    if (!active.length) { saveQueue([]); return; }
    saveQueue(active);
    active.forEach(function (item) { sendQueued(item, 1); });
  }
  function event(journey, name, sequence, extra) {
    var assigned = assignment();
    var payload = {
      kind: 'header_journey', schema_version: 'CLEAR_202609_V2', tracker_version: String(config.trackerVersion || 'CLEAR_WEB_02'),
      environment: environment, campaign_id: 'CLEAR_202609', lottery_type: 'CLEAR', event_id: uuid('che_'),
      event_time: new Date().toISOString(), visitor_id: visitorId(), session_id: sessionId(),
      experiment_id: assigned ? experimentId : '', experiment_variant: assigned ? 'A' : '',
      experiment_assigned_at: assigned ? assigned.assigned_at || '' : '', experiment_enrolled: Boolean(assigned),
      event_name: name, header_journey_id: journey ? journey.header_journey_id : '', sequence_no: sequence || 0,
      source_path: path, destination_path: '', destination_url: '', page_path: path, page_category: pageCategory(path),
      header_target: '', click_label: '', header_device_context: window.innerWidth < 769 ? 'mobile' : 'desktop',
      header_exit_at: journey ? journey.header_exit_at : '', return_at: '', return_seconds: ''
    };
    Object.keys(extra || {}).forEach(function (key) { payload[key] = extra[key]; });
    payload.destination_url = sanitizedUrl(payload.destination_url);
    payload.destination_path = payload.destination_path ? normalizePath(payload.destination_path) : '';
    if (!valid(payload.visitor_id, 'cv_') || !valid(payload.session_id, 'cs_')) return;
    enqueue(payload);
  }
  function targetInfo(node) {
    var hrefNode = node.closest && node.closest('a[href]');
    var text = clean((node.closest && node.closest('a,button')) ? node.closest('a,button').textContent : '', 120);
    var element = hrefNode || (node.closest && node.closest('button')) || node;
    var classes = String(element && element.className || '');
    var href = hrefNode ? hrefNode.href : '';
    var target = 'other';
    if (node.closest && node.closest('.header-item--logo')) target = 'logo';
    else if (/js-search-header/.test(classes) || (href && normalizePath(internalUrl(href) && internalUrl(href).pathname) === '/search')) target = 'search';
    else if (/js-drawer-open-cart/.test(classes) || (href && normalizePath(internalUrl(href) && internalUrl(href).pathname) === '/cart')) target = 'cart';
    else if (/js-drawer-open-nav/.test(classes)) target = 'menu';
    else if ((node.closest && node.closest('shopify-account')) || /account/.test(href)) target = 'account';
    else if (hrefNode && node.closest && node.closest('#NavDrawer, [role="navigation"], .site-nav')) target = 'menu_item';
    var opensOverlay = /js-search-header|js-drawer-open-cart|js-drawer-open-nav/.test(classes);
    return { target: target, label: text, href: href, url: href ? internalUrl(href) : null, exits: Boolean(hrefNode && !opensOverlay && internalUrl(href) && normalizePath(internalUrl(href).pathname) !== '/pages/clearlp') };
  }
  function onHeaderClick(clickEvent) {
    if (!isLpA || !clickEvent.isTrusted || !clickEvent.target || !clickEvent.target.closest) return;
    var inHeader = clickEvent.target.closest('#HeaderWrapper, #NavDrawer');
    var inHeaderOverlay = pendingInteraction && clickEvent.target.closest('#CartDrawer, predictive-search, .predictive-search-results');
    if (!inHeader && !inHeaderOverlay) return;
    var info = targetInfo(clickEvent.target), current = readJourney();
    if (!info.exits) {
      pendingInteraction = { visitor_id: visitorId(), origin_session_id: sessionId(), target: info.target,
        label: info.label, created_at: Date.now() };
      event(null, 'header_click', 0, { header_target: info.target, click_label: info.label,
        destination_url: info.url ? info.url.href.slice(0, 500) : '', destination_path: info.url ? normalizePath(info.url.pathname) : '' });
      return;
    }
    var assigned = assignment();
    var pending = pendingInteraction && Date.now() - pendingInteraction.created_at < 10 * 60 * 1000 ? pendingInteraction : null;
    var journey = { header_journey_id: uuid('chj_'), header_exit_at: new Date().toISOString(), header_exit_ms: Date.now(),
      sequence_no: 1, visitor_id: visitorId(), origin_session_id: sessionId(), experiment_id: assigned ? experimentId : '', experiment_variant: assigned ? 'A' : '' };
    var exitTarget = pending && (pending.target === 'search' || pending.target === 'cart') ? pending.target : info.target;
    pendingInteraction = null;
    saveJourney(journey);
    if (!pending) event(null, 'header_click', 0, { header_target: info.target, click_label: info.label, destination_url: info.url.href.slice(0, 500), destination_path: normalizePath(info.url.pathname) });
    event(journey, 'header_exit', 1, { header_target: exitTarget, click_label: info.label, destination_url: info.url.href.slice(0, 500), destination_path: normalizePath(info.url.pathname) });
  }
  function onSearchSubmit(submitEvent) {
    if (!isLpA || !pendingInteraction || pendingInteraction.target !== 'search' || Date.now() - pendingInteraction.created_at >= 10 * 60 * 1000) return;
    var form = submitEvent.target, action = form && form.action ? internalUrl(form.action) : null;
    if (!action || normalizePath(action.pathname) !== '/search') return;
    var assigned = assignment();
    var journey = { header_journey_id: uuid('chj_'), header_exit_at: new Date().toISOString(), header_exit_ms: Date.now(),
      sequence_no: 1, visitor_id: visitorId(), origin_session_id: sessionId(), experiment_id: assigned ? experimentId : '', experiment_variant: assigned ? 'A' : '' };
    pendingInteraction = null;
    saveJourney(journey);
    event(journey, 'header_exit', 1, { header_target: 'search', click_label: '', destination_url: action.href.slice(0, 500), destination_path: '/search' });
  }
  function recordPage() {
    var journey = readJourney();
    if (!journey || journey.return_at || path === '/pages/thanks') return;
    journey.sequence_no = Number(journey.sequence_no || 1) + 1;
    saveJourney(journey);
    event(journey, 'page_view', journey.sequence_no, {});
    if (isLpA && !journey.return_at) {
      journey.return_at = new Date().toISOString();
      journey.sequence_no += 1;
      saveJourney(journey);
      event(journey, 'lp_return_after_header', journey.sequence_no, { return_at: journey.return_at,
        return_seconds: Math.max(0, Math.round((Date.now() - Number(journey.header_exit_ms || Date.now())) / 1000)) });
    }
  }

  resendApplicationPending();
  if (!isLpA && !readJourney() && !queue().length) return;
  flushQueue();
  recordPage();
  if (isLpA) {
    document.addEventListener('click', onHeaderClick, true);
    document.addEventListener('submit', onSearchSubmit, true);
  }
  if (environment === 'test') window.HENGE_CLEAR_HEADER_JOURNEY_TEST = { pageCategory: pageCategory, getJourney: readJourney, flush: flushQueue };
})();
